<script>
    import { apiUrl, removeDuplicates } from "@/utils";

    export default {
        name: "ProductColorImageList",
        props: {
            currentOffer: Object,
            offers: Array,
        },
        data() {
            return {
                currentColor: this.currentOffer.previewImage?.small,
                timeoutID: null,
            };
        },
        watch: {
            "currentOffer.id"() {
                this.currentColor = this.currentOffer.previewImage?.small;
            },
        },
        computed: {
            listColors() {
                return removeDuplicates(
                    this.offers
                        .filter((offer) => offer.color && offer.previewImage.small)
                        .map((offer) => {
                            return {
                                color: offer.color,
                                image: offer.previewImage.small,
                                isAvailable: offer.available,
                            };
                        })
                        .sort((a, b) => b.isAvailable - a.isAvailable)
                );
            },
        },
        methods: {
            selectColor(value) {
                this.currentColor = value.image;
                this.$emit("select-color", value.color.id);
            },
            mouseEnterHandler(value) {
                clearTimeout(this.timeoutID);
                this.$emit("set-color", value.color.name);
            },
            mouseLeaveHandler() {
                this.currentDebounce(() => {
                    this.$emit("reset-color", "");
                }, 300)();
            },
            currentDebounce(fn, delay) {
                return () => {
                    clearTimeout(this.timeoutID);
                    let args = arguments;
                    this.timeoutID = setTimeout(() => {
                        fn.apply(this, args);
                    }, delay);
                };
            },
            apiUrl,
        },
    };
</script>

<template>
    <div class="c-color-list-image">
        <div
            class="c-color-list-image__item"
            :class="{
                'c-color-list-image__item--active': currentColor === item.image,
                'c-color-list-image__item--disabled': !item.isAvailable,
            }"
            v-for="item in listColors"
            :key="item.color.id"
            @click="selectColor(item)"
            @mouseenter="mouseEnterHandler(item)"
            @mouseleave="mouseLeaveHandler"
        >
            <img :src="apiUrl(item.image)" :alt="item.color.name + ' цвет'" />
        </div>
    </div>
</template>

<style lang="scss">
    .c-color-list-image {
        display: flex;
        flex-wrap: var(--color-list-wrap);
    }

    .c-color-list-image__item {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        @include box(var(--size-color-box-sm));
        border-radius: var(--color-list-radius);
        transition: box-shadow 0.2s ease-in;
        cursor: pointer;
        border: var(--color-list-border-width) solid var(--color-list-border);
        overflow: hidden;

        @include bp($bp-tablet-sm) {
            @include box(var(--size-color-box-lg));
        }

        &:hover {
            img {
                transform: scale(1);
            }
        }

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: contain;
            transform: scale(0.96);
            transition: 0.3s ease-in-out transform;
            font-size: 10px;
        }
    }

    //
    // --mod
    //

    .c-color-list-image__item--active {
        pointer-events: none;
        border-color: var(--secondary);
    }

    .c-color-list-image__item--disabled {
        position: relative;
        overflow: hidden;
        &:not(.c-color-list-image__item--active) {
            border-color: var(--color-list-border--disabled);
        }
        &::before {
            content: "";
            @include center-absolute(0);
            z-index: 2;
            background-color: rgba(0, 84, 144, 0.05);
        }

        img {
            opacity: 0.5;
        }
    }
</style>
